import { DefaultOptions, QueryClient, QueryClientConfig } from 'react-query';

import { deprecated_withV3Semantics } from 'utils/deprecated_withV3Semantics';

export const QUERY_STALE_TIME_IN_SECONDS = 30 * 60 * 60;

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME_IN_SECONDS,
      retry: false,
      networkMode: 'offlineFirst',
      notifyOnChangeProps: 'all',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
};

export const createAppQueryClient = (queryDefaults: DefaultOptions['queries'] = {}): QueryClient =>
  deprecated_withV3Semantics(
    new QueryClient({
      ...queryClientConfig,
      defaultOptions: {
        ...queryClientConfig.defaultOptions,
        queries: { ...queryClientConfig.defaultOptions?.queries, ...queryDefaults },
      },
    }),
  );
